import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { BaseStationFieldName } from '../base-stations-listing-page.types';

export const BASE_STATION_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ALL,
    value: 1,
    types: [BaseStationFieldName.DeviceUId, BaseStationFieldName.MacId],
    hintText: SEARCH_HINTS.DeviceIdOrMacId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.DEVICE_ID,
    value: 2,
    types: [BaseStationFieldName.DeviceUId],
    hintText: SEARCH_HINTS.DeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.MAC_ID,
    value: 3,
    types: [BaseStationFieldName.MacId],
    hintText: SEARCH_HINTS.MacId
  }
];

export const BASE_STATION_DEFAULT_SEARCH_TYPE: SearchType = BASE_STATION_SEARCH_TYPES[0];
